/** 告知ページのパス。バナー・ダイアログ・遷移制御から参照する */
export const CARE_GACHA_ANNOUNCEMENT_PATH = "/careGacha";

export type ViewerForCareGachaAnnouncement = {
  status: string | null;
};

/**
 * ケアガチャ事前告知（バナー・ダイアログ・告知ページ）の表示対象か。
 * 応募制限中は status が enabled のままなので、ここでは除外しない（要件 表A の A2）。
 * 要件が「利用停止」と呼ぶのは forced_withdrawn のこと。画面表記の「利用停止中」は
 * isSuspended（要件の応募制限中）を指すので取り違えないこと。
 * 利用停止はガチャを利用できないため対象外。
 * 退会はログイン自体ができないため、ここには現れない。
 */
export const isEligibleForCareGachaAnnouncement = (
  viewer: ViewerForCareGachaAnnouncement | null | undefined,
): boolean => {
  if (!viewer) return false;
  return viewer.status !== "forced_withdrawn";
};
